import { selectHasAlertsAccess } from '@bo-selectors/alerts/alerts';
import { useGetAlertNotificationsCountQuery } from '@bo-services/alertsApi';
import { useSelector } from 'react-redux';

export const useAlertNotificationsCount = () => {
  const hasAlertsAccess = useSelector(selectHasAlertsAccess);
  const { data: unreadAlertNotificationsCount } =
    useGetAlertNotificationsCountQuery(undefined, {
      skip: !hasAlertsAccess
    });

  return {
    hasAlertsAccess,
    unreadAlertNotificationsCount
  };
};
